import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import React, { useState, useEffect } from "react";
import { Redirect, useHistory } from "react-router-dom";
import GearJson from '../gear_cats_update.json'
import BrandJson from '../brand_cats.json'
import StorageLocation from '../locations_cats.json'
import FoodSample from '../food_sample.json'
import GearSample from '../gear_sample.json'
import TripsSample from '../trips_sample.json'
import firebaseConfig from "../config";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCcVisa, faCcMastercard, faCcAmex } from "@fortawesome/free-brands-svg-icons"

function CheckoutForm() {
  
  // collect data from the user
  const [name, setName] = useState("");
  const [lname, setLName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [coupon, setCoupon] = useState("");
  const [promo, setPromo] = useState("");
  const [promovalid, setPromoValid] = useState("");
  const [promovalidy, setPromoValidY] = useState("red");
  const [showResults, setShowResults] = useState(false);
  const [priceId, setPriceId] = useState("price_1N1TKrGxUje7SlyIeNldQvLT");
  const [passwordShown, setPasswordShown] = useState(false);
  const [promotext, setPromoText] = useState(null);

  const [countrycode, setCountryCode] = useState("");

  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };
  const [processing, setProcessing] = useState(true);
  const [wait, setWait] = useState('SUBSCRIBE');
  const [error, setError] = useState(null);

  const history = useHistory();

  const onClickCode = () => {
    setShowResults(!showResults);
  }

  const handleChange = async (event) => {
    setProcessing(false);
  };

  let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const handleFormChangeFN = async (e) => {
    if (e.target.value.length < 2 || e.target.value == '') {
      setError('Please enter your first name');
      setProcessing(true);
    } else {
      setError(null);
    }
  };

  const handleFormChangeLN = async (e) => {
    if (e.target.value.length < 2 || e.target.value == '') {
      setError('Please enter your last name');
      setProcessing(true);
    } else {
      setError(null);
    }
  };

  const handleFormChangeEM = async (e) => {
    if (!regEmail.test(e.target.value)) {
      setError('Email format is incorrect')
      setProcessing(true);
    } else {
      setError(null);
    }
  };

  const handleFormChangePW = async (e) => {
    if (e.target.value.length < 8 || e.target.value == '') {
      setError('Password must be at least 8 characters');
      setProcessing(true);
    } else {
      setError(null);
    }
  };

  const handleFormChangePC = async (e) => {
    if (e.target.value == 'BETA') {
      setPromo('promo_1N1ienGxUje7SlyIX3wTtl5Z');
      setPromoValidY('green');
      setPromoValid('✓');
      setPromoText('40% OFF FOR FIRST YEAR');
    } else if (e.target.value == 'EXPO' || e.target.value == 'expo' || e.target.value == 'Expo') {
      setPromo('promo_1N3AR7GxUje7SlyIxjcqEklp');
      setPromoValidY('green');
      setPromoValid('✓');
      setPromoText('FIRST YEAR $30USD');
    } else {
      setPromo('');
      setPromoValidY('red');
      setPromoValid('✗');
      setPromoText(null);
    }
  };

  // stripe items
  const stripe = useStripe();
  const elements = useElements();

  const cardStyle = {
      base: {
        color: "#fff",
        fontFamily: 'Arial, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        lineHeight: "35px",
        padding: "35px",
        "::placeholder": {
          color: "#a2a2a2"
        }
      },
      invalid: {
        fontFamily: 'Arial, sans-serif',
        color: "#fa755a",
        iconColor: "#fa755a"
      }
  };

  useEffect(() => {
      fetch('https://api.ipregistry.co/?key=tv18lre45zray6sz')
        .then(function (response) {
            return response.json();
        })
        .then(function (payload) {
            setCountryCode(payload.location.country.code + "D");
        });
    }
  )
  
  // main function
  const createSubscription = async () => {
    setProcessing(true);
    setWait('PLEASE WAIT');
    try {
      
      // create a payment method
      const paymentMethod = await stripe?.createPaymentMethod({
        type: "card",
        card: elements?.getElement(CardElement),
        billing_details: {
          name,
          email,
        },
      });

      // call the backend to create subscription
      const response = await fetch("https://australia-southeast1-trip-planner-7fc5a.cloudfunctions.net/tplannersubscriptiontrial", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          paymentMethod: paymentMethod?.paymentMethod?.id,
          name,
          lname,
          email,
          promo,
          countrycode,
          priceId
        }),
      }).then((res) => res.json());
           
      // confirmCardSetup

      const confirmPayment = await stripe?.confirmCardSetup(
        response.clientSecret
      );

      if (confirmPayment?.error) {
        console.log(confirmPayment.error.message);
      } else {
        setProcessing(true);
        setWait('SUBSCRIBED!')
        setError('Thank you for subscribing');

        firebaseConfig.auth().createUserWithEmailAndPassword(email, password)
            .then(id => {
              if (id) {
                const data = {
                  id: id.user.uid,
                  storageLocation: StorageLocation,
                  Brand: BrandJson,
                  planid: 'WEB',
                  Travellers: [{Name:'', Weight:''}],
                  FourbyFourPlusCaravan: {FourbyFour_Empty: 0, FourbyFour_Payload: 0, FourbyFour_Water: 0, FourbyFour_GVM: 0, FourbyFour_FUEL: 0, FourbyFour_TOTAL: 0, id: Math.random() * 6 * 10},
                  AdventureMotorBike: {AdventureMotorBike_Empty: 0, AdventureMotorBike_GVM: 0, AdventureMotorBike_Payload: 0, AdventureMotorBike_Fuel: 0, AdventureMotorBike_Water: 0, AdventureMotorBike_Total: 0, id: Math.random() * 6 * 10},
                  BoatWeight: {BoatWeight_Empty: 0, BoatWeight_ATM: 0, BoatWeight_Payload: 0, BoatWeight_Water: 0, BoatTotal: 0, BoatforbyforTotal: 0, BoatWeight_Fuel: 0, BoatWeight_forbyfor_BoatBall: 0, BoatWeight_GCM: 0, id: Math.random() * 6 * 10},
                  Caravan: {Caravan_Empty: 0, Caravan_ATM: 0, Caravan_Payload: 0, Caravan_Water: 0, Caravan_Greywater: 0, Caravan_Total: 0, Caravan_forbyfor_Total: 0, caravan_forbyfor_caravanBall: 0, caravan_GCM: 0, id: Math.random() * 6 * 10},
                  Camper: {Camper_Empty: 0, Camper_ATM: 0, Camper_Payload: 0, Camper_Water: 0, Camper_Total: 0, Camper_CamperBall: 0, Camper_forbyfor_Total: 0, CamperplusforbyforTotal: 0, camperforbyfor_GCM: 0, id: Math.random() * 6 * 10},
                  Subcription_Status: true,
                  Stripe: response.subID,
                  plancreated: new Date(),
                  planexpiry: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
                  email: id.user.email,
                  GearCategories: GearJson
                }
                firebaseConfig
                  .firestore()
                  .collection('user')
                  .doc(id.user.uid)
                  .set(data)
                  .then(() => {
                    setCurrentUser(true);
                  });

                  const foodarray = FoodSample.map((array) => ({
                    ...array,
                    User: id.user.uid,
                  }));
                                  
                  foodarray.forEach((doc) => {
                    firebaseConfig.firestore().collection("food").doc().set(doc);
                  });
  
                  const geararray = GearSample.map((array) => ({
                    ...array,
                    User: id.user.uid,
                  }));
                                  
                  geararray.forEach((doc) => {
                    firebaseConfig.firestore().collection("gear").doc().set(doc);
                  });
                  
                  const tripsarray = TripsSample.map((array) => ({
                    ...array,
                    User: id.user.uid,
                    DateFrom: new Date(Date.now() + ( 3600 * 1000 * 120)),
                    DateTo: new Date(Date.now() + ( 3600 * 1000 * 240))
                  }));
                                  
                  tripsarray.forEach((doc) => {
                    firebaseConfig.firestore().collection("trips").doc().set(doc);
                  });
              }
            }).catch(err => {
              console.log(err);
            });
            history.push('/welcome')
      }
    } catch (error) {
      setProcessing(false);
      setWait('SUBSCRIBE');
      setError('Please enter your credit card details');
      console.log(error);
    }
  };

  return (
    <>
    <Box sx={{ maxWidth: 450, textAlign: 'center', margin: 'auto' }}>
    <Card variant="outlined">
    <CardContent>
    { /* 7-DAY FREE TRIAL */ }
    <form>
      <input  // this should not be a text field. maybe a radio button ro something
        placeholder="Price Id"
        type="text"
        value={priceId}
        onChange={(e) => setPriceId(e.target.value)}
        style={{display:'none'}}
      />
      <TextField
        required
        variant="outlined"
        label="First Name"
        type="text"
        value={name}
        onChange={(e) => { setName(e.target.value); handleFormChangeFN(e); }}
        style={{width:'47%'}}
      /><span className="mobilehide">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <TextField
        required
        variant="outlined"
        label="Last Name"
        type="text"
        value={lname}
        onChange={(e) => { setLName(e.target.value); handleFormChangeLN(e); } }
        style={{width:'47%'}}
      /><br/>
      <TextField
        required
        variant="outlined"
        label="Email"
        type="email"
        value={email}
        onChange={(e) => { setEmail(e.target.value); handleFormChangeEM(e); }}
        style={{width:'100%'}}
      /><br/>
      <TextField
        required
        variant="outlined"
        label="Choose Password"
        type={passwordShown ? "text" : "password"}
        value={password}
        onChange={(e) => { setPassword(e.target.value); handleFormChangePW(e); }}
        style={{width:'100%'}}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <VisibilityOutlinedIcon style={{color:'#fff', cursor:'pointer'}} onClick={togglePassword} />
            </InputAdornment>
          ),
        }}
      />
      <CardElement options={{hidePostalCode: true, style: cardStyle}} onChange={handleChange} />
      <div className="cclogos">
      <FontAwesomeIcon icon={faCcVisa} /> <FontAwesomeIcon icon={faCcMastercard} /> <FontAwesomeIcon icon={faCcAmex} />
      </div>
      <Button variant="outlined" onClick={onClickCode} style={{color:'#fff', float:'left', width:'33%', margin:'10px 0', borderColor:'#fff'}}>Promo Code</Button>
      { showResults ?
      <>
      <TextField
        variant="outlined"
        label="Promo Code"
        type="text"
        value={coupon}
        onChange={(e) => { setCoupon(e.target.value); handleFormChangePC(e); }}
        className="promo_code"
        style={{float: 'right', width:'60%', margin:'0', textTransform:'uppercase'}}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <div style={{color:promovalidy}}>{promovalid}</div>
            </InputAdornment>
          ),
        }}
      /><div style={{clear:'both', color:'#ef4822', fontSize:'12px', textAlign: 'right', padding:'5px 0'}}>{promotext}</div> </>: null }
      <div style={{clear:'both'}}></div><br/>
      <Button className="subbtn" onClick={createSubscription} disabled={processing} size="large" variant="outlined">
        {wait}
      </Button>
      <span style={{color: '#fff', fontSize:'10px'}}>Cancel easily anytime before renewal.</span>
      <div style={{display:'block', color:'#ff7474', fontSize:'11px', height:'40px', lineHeight:'40px'}}>
      {error}
      </div>
    </form>
    <>
    </>
    </CardContent>
    </Card>
    </Box>
    </>
  );
}

export default CheckoutForm;